module.exports = __webpack_public_path__ + "img/icon-hamburger.9eaf7808.svg";